export const CSM_TYPE = {
  OFFLINE: 0,
  ONLINE: 1,
};

export const CSM_STATE = {
  OFF: 0,
  ON: 1,
};

export const CSM_COPY = {
  OFF: 0,
  ON: 1,
};

export const CSM_PAGE_SIZE = 20;
export const DEFAULT_LANG = 'default';

export const CSM_TYPE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(CSM_TYPE.OFFLINE), label: '線下客服' },
  { value: String(CSM_TYPE.ONLINE), label: '在線客服' },
];

export const CSM_STATE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(CSM_STATE.ON), label: '啟用' },
  { value: String(CSM_STATE.OFF), label: '禁用' },
];

export const CSM_FORM_STATE_OPTIONS = [
  { value: CSM_STATE.ON, label: '啟用' },
  { value: CSM_STATE.OFF, label: '禁用' },
];

export const CSM_FORM_COPY_OPTIONS = [
  { value: CSM_COPY.ON, label: '是' },
  { value: CSM_COPY.OFF, label: '否' },
];

export const ONLINE_PROVIDER_TRANSFER_OPTIONS = [
  { value: 1, label: '直接調用第三方客服鏈接地址' },
  { value: 2, label: '直接調用第三方客服鏈接地址(跳出平台)' },
  { value: 3, label: '自平台內嵌第三方客服頁面' },
];

export function buildCustomerServiceManagementPageParams(pageNo, filters = {}, pageSize = CSM_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.state !== '' && filters.state != null) {
    params.state = Number(filters.state);
  }
  if (filters.type !== '' && filters.type != null) {
    params.type = Number(filters.type);
  }
  if (filters.name?.trim()) {
    params.name = filters.name.trim();
  }
  return params;
}

export function formatCustomerServiceManagementState(state) {
  return state === CSM_STATE.ON ? '啟用' : '禁用';
}

export function formatCustomerServiceManagementType(type) {
  return type === CSM_TYPE.ONLINE ? '在線客服' : '線下客服';
}

export function formatCopyStatus(copyStatus) {
  return copyStatus === CSM_COPY.ON ? '是' : '否';
}

export function formatDisplayType(row) {
  if (row?.type === CSM_TYPE.OFFLINE) {
    return '帳號';
  }
  const matched = ONLINE_PROVIDER_TRANSFER_OPTIONS.find(
    (opt) => opt.value === row?.onlineProviderTransferType
  );
  return matched?.label || '—';
}

export function emptyCustomerServiceManagementDetail(lang) {
  return {
    lang,
    name: '',
    buttonName: '',
  };
}

export function mergeCustomerServiceManagementDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyCustomerServiceManagementDetail(code), _label: label };
  });
}

export function stripCustomerServiceManagementDetails(details) {
  return (details || []).map(({ lang, name, buttonName }) => ({
    lang,
    name: name || '',
    buttonName: buttonName || '',
  }));
}

export function mergeCustomerImageConfigWithLanguages(languages, existingConfigs = []) {
  const entries = [{ code: DEFAULT_LANG, label: '預設', required: true }];
  const seen = new Set([DEFAULT_LANG]);

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    entries.push({
      code,
      label: lang.label || code,
      required: false,
    });
  });

  const map = new Map((existingConfigs || []).map((item) => [item.lang, { ...item }]));
  return entries.map(({ code, label, required }) => {
    const found = map.get(code);
    return {
      lang: code,
      imageUrl: found?.imageUrl || '',
      _label: label,
      _required: required,
    };
  });
}

export function stripCustomerImageConfigs(configs) {
  return (configs || [])
    .filter((item) => item?.imageUrl?.trim())
    .map(({ lang, imageUrl }) => ({
      lang,
      imageUrl: imageUrl.trim(),
    }));
}
